module.exports = __webpack_public_path__ + "static/media/MrDanielCHEUNG.7bb539e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub2/MrDanielCHEUNG.jpg
// module id = 208
// module chunks = 0